import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { optInKEX, optOutKEX } from '../organizations/slice';
import { getKEXProfiles, getKEXProfile, patchExistingKEXProfile, postNewKEXProfile, removeKEXProfile } from './data';
import { errorReceiveCreateKEXProfile, errorReceiveModifyKEXProfile, errorReceiveRemoveKEXProfile, errorReceiveSourceKEXProfile, errorReceiveTargetKEXProfile, failedReceiveCreateKEXProfile, failedReceiveModifyKEXProfile, failedReceiveRemoveKEXProfile, failedReceiveSourceKEXProfile, failedReceiveTargetKEXProfile, receiveCreateKEXProfile, receiveModifyKEXProfile, receiveRemoveKEXProfile, receiveSourceKEXProfile, receiveTargetKEXProfile } from './slice';
export function* requestCreateKEXProfile(action) {
    try {
        const { consumerAPI, kexProfilePayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postNewKEXProfile, organization, kexProfilePayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCreateKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveCreateKEXProfile(data));
                yield put(optInKEX(organization, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCreateKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveCreateKEXProfile(response.data));
                yield put(optInKEX(organization, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCreateKEXProfile());
    }
}
export function* requestModifyKEXProfile(action) {
    try {
        const { consumerAPI, kexProfileId, kexProfilePayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchExistingKEXProfile, organization, kexProfileId, kexProfilePayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyKEXProfile(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyKEXProfile(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyKEXProfile());
    }
}
export function* requestRemoveKEXProfile(action) {
    try {
        const { consumerAPI, kexProfileId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeKEXProfile, organization, kexProfileId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveRemoveKEXProfile());
                yield put(optOutKEX(organization, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 204) {
                yield put(errorReceiveRemoveKEXProfile());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 204) {
                yield put(receiveRemoveKEXProfile());
                yield put(optOutKEX(organization, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveKEXProfile());
    }
}
export function* requestSourceKEXProfile(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getKEXProfiles, organization, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveSourceKEXProfile());
            }
            else if (data && data.length > 0) {
                yield put(receiveSourceKEXProfile(data[0]));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveSourceKEXProfile());
            }
            else if (response && response.status === 200) {
                yield put(receiveSourceKEXProfile(response.data[0]));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveSourceKEXProfile());
    }
}
export function* requestTargetKEXProfile(action) {
    try {
        const { consumerAPI, kexProfileId, targetOrganization } = action.payload;
        const response = yield call(getKEXProfile, targetOrganization, kexProfileId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveTargetKEXProfile());
            }
            else if (data) {
                yield put(receiveTargetKEXProfile(data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveTargetKEXProfile());
            }
            else if (response && response.status === 200) {
                yield put(receiveTargetKEXProfile(response.data));
            }
            else {
                throw new Error(t('ERROR_RETRIEVE_KEX_PROFILE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveTargetKEXProfile());
    }
}
export function* watchRequestCreateKEXProfile() {
    yield takeLatest('kexProfiles/requestCreateKEXProfile', requestCreateKEXProfile);
}
export function* watchRequestModifyKEXProfile() {
    yield takeLatest('kexProfiles/requestModifyKEXProfile', requestModifyKEXProfile);
}
export function* watchRequestRemoveKEXProfile() {
    yield takeLatest('kexProfiles/requestRemoveKEXProfile', requestRemoveKEXProfile);
}
export function* watchRequestSourceKEXProfile() {
    yield takeLatest('kexProfiles/requestSourceKEXProfile', requestSourceKEXProfile);
}
export function* watchRequestTargetKEXProfile() {
    yield takeLatest('kexProfiles/requestTargetKEXProfile', requestTargetKEXProfile);
}
